import React, {Component} from 'react';
import Timestamp from 'react-timestamp';
import {htmlDecode} from '../util';

/** The Card component expects a JSON object representing
    a Reddit thread and renders it in a MUI 'card' */
class Card extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);

    this.state = {expanded: false};
    this.handleExpand = this.handleExpand.bind(this);
  }

  /**
   * Certain Reddit threads contain rich media content which can be inlined on the page.
   * If the thread contains one of these content types the view controls are switched so
   * the content is expandable.
   * @returns {string} JSX representation of the expanded controls.
   */
  renderExpandControls() {
    const {thread} = this.props;
    if (
      thread.data.post_hint === 'image' ||
      thread.data.post_hint === 'rich:video'
    ) {
      if (this.state.expanded) {
        return (
          <a
            className="waves-effect waves-light close"
            onClick={this.handleExpand}
          >
            <i className="material-icons right">expand_less</i>Compress
          </a>
        );
      } else {
        return (
          <a
            className="waves-effect waves-light open"
            onClick={this.handleExpand}
          >
            <i className="material-icons right">expand_more</i>Expand
          </a>
        );
      }
    } else {
      return (
        <a
          className="waves-effect waves-light view"
          href={thread.data.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="material-icons right">visibility</i>View
        </a>
      );
    }
  }

  /**
   * Renders content which can be expandable into view. If it's an image an image tag is returned,
   * for a rich:video embed type an inline iFrame is returned.
   * @returns {string} JSX representation of the expandable content.
   */
  renderExpandContent() {
    const {thread} = this.props;

    if (thread.data.post_hint === 'image') {
      return (
        <img
          src={thread.data.url}
          className="img-responsive"
          alt={thread.data.title}
        />
      );
    } else if (thread.data.post_hint === 'rich:video') {
      return (
        <div
          className="iframe-responsive"
          dangerouslySetInnerHTML={{
            __html: htmlDecode(thread.data.secure_media_embed.content),
          }}
        />
      );
    }
  }

  /**
   * Toggles the expanded content state.
   * @returns {undefined}
   */
  handleExpand() {
    this.setState({expanded: !this.state.expanded});
  }

  /**
   * Renders the Card component.
   * @returns {string} JSX representation of the component.
   */
  render() {
    const {thread} = this.props;

    /* Certain thumbnail paths from the Reddit API's indicate a content type and not
    	an image. For these we re-assign their values a placeholder so they
    	can be rendered in an image tag. */
    if (thread.data.thumbnail === 'self') {
      thread.data.thumbnail = './assets/placeholder_self.png';
    } else if (thread.data.thumbnail === 'nsfw') {
      thread.data.thumbnail = './assets/placeholder_nsfw.png';
    } else if (thread.data.thumbnail === 'spoiler') {
      thread.data.thumbnail = './assets/placeholder_spoiler.png';
    } else if (
      thread.data.thumbnail === '' ||
      thread.data.thumbnail === 'default'
    ) {
      thread.data.thumbnail = './assets/placeholder.png';
    }

    return (
      <div key={thread.data.id} className="col s12">
        <div className="card hoverable horizontal">
          <div className="card-image">
            <img src={thread.data.thumbnail} alt={thread.data.title} />
          </div>

          <div className="card-stacked">
            <div className="card-content">
              <span className="card-title-text">
                <a
                  href={`https://reddit.com${thread.data.permalink}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {thread.data.title}
                </a>
              </span>

              <div className="card-meta">
                Posted by{' '}
                <a
                  className="card-author"
                  href={`https://www.reddit.com/user/${thread.data.author}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {thread.data.author}
                </a>{' '}
                <Timestamp time={thread.data.created_utc} />
              </div>

              <div className="chip-list">
                {thread.data.over_18 && <div className="chip">nsfw</div>}
                {thread.data.post_hint && (
                  <div className="chip">{thread.data.post_hint}</div>
                )}
              </div>
            </div>

            <div className="card-action">
              <div className="action-list">
                <span>{this.renderExpandControls()}</span>
              </div>
            </div>
          </div>

          {this.state.expanded && (
            <div className="card-expand">{this.renderExpandContent()}</div>
          )}
        </div>
      </div>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.js